import React, { useEffect, useMemo, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Moment from 'moment'

import yt from "../img/yt.png";
import spotify from "../img/spotify.png";
import granada from "../img/granadal2.png";
import escuchar from "../img/escuchar.png";

function getModalStyle() {
    return {
        top: `${50}%`,
        left: `${50}%`,
        transform: `translate(-${50}%, -${50}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        position: "absolute",
        width: "fit-content",
        backgroundColor: "#151515",
        border: "2px solid #000",
        boxShadow: theme.shadows[5],
        padding: "25px",
        outline: "none",
        maxWidth: "90vw",
    },
}));

const spotifyEmbed = (url) => {
    if (!url) return null;
    if (url.includes('/show/')) return url.replace('open.spotify.com/show/', 'open.spotify.com/embed/show/').split('?')[0];
    if (url.includes('/album/')) return url.replace('open.spotify.com/album/', 'open.spotify.com/embed/album/').split('?')[0];
    if (url.includes('/track/')) return url.replace('open.spotify.com/track/', 'open.spotify.com/embed/track/').split('?')[0];
    return url;
}

const AUDIO_PROXY = 'https://guasaspotv-audio-proxy.imbaworkers.workers.dev';

const toDriveStream = (url) => {
    if (!url) return url;
    const full = url.includes('drive.google.com') ? url : `https://drive.google.com/file/d/${url}`;
    const byFile = full.match(/\/d\/([A-Za-z0-9_-]+)/);
    if (byFile) return `${AUDIO_PROXY}/?id=${byFile[1]}`;
    const raw = url.match(/^([A-Za-z0-9_-]{20,})(\/view\?usp=.*)?$/);
    if (raw) return `${AUDIO_PROXY}/?id=${raw[1]}`;
    return url;
}

const formatTime = (secs) => {
    if (!Number.isFinite(secs) || secs < 0) return '00:00';
    const minutes = Math.floor(secs / 60);
    const seconds = Math.floor(secs % 60);
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export default function SimpleModal({ imagen, contenido = [], na, naa, ano, numcanciones, minutosalbum, spotifylink, youtubelink }) {
    const site = "https://api.guasasapo.cl";
    const classes = useStyles();
    const [modalStyle] = useState(getModalStyle);
    const [open, setOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef(null);
    const hasTracks = contenido && contenido.length > 0;

    const tracks = useMemo(() => {
        return (contenido || []).map((item, index) => ({
            ...item,
            index,
            streamUrl: toDriveStream(item.URL),
        }));
    }, [contenido]);

    const currentTrack = hasTracks ? tracks[currentIndex] : null;

    const loadAndPlayTrack = (track) => {
        if (!audioRef.current || !track) return;
        const audio = audioRef.current;
        const attemptPlay = () => {
            const playPromise = audio.play();
            if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.then(() => setIsPlaying(true)).catch(() => setIsPlaying(false));
            } else {
                setIsPlaying(true);
            }
        };
        audio.pause();
        audio.src = track.streamUrl;
        audio.currentTime = 0;
        audio.load();
        audio.oncanplay = () => {
            audio.oncanplay = null;
            attemptPlay();
        };
        attemptPlay();
    };

    useEffect(() => {
        if (!open || !currentTrack) return;
        loadAndPlayTrack(currentTrack);
    }, [currentIndex, currentTrack, open]);

    const handleOpen = () => {
        setCurrentIndex(0);
        setCurrentTime(0);
        setDuration(0);
        setIsPlaying(true);
        setOpen(true);

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const firstTrack = tracks[0];
                if (!firstTrack) return;
                loadAndPlayTrack(firstTrack);
            });
        });
    };

    const handleClose = () => {
        if (audioRef.current) audioRef.current.pause();
        setOpen(false);
        setIsPlaying(false);
    };

    const handleClickAway = () => {
        if (audioRef.current) audioRef.current.pause();
        setOpen(false);
        setIsPlaying(false);
    };

    const playTrackAt = (index) => {
        const track = tracks[index];
        if (!track) return;
        setCurrentIndex(index);
        setCurrentTime(0);
        setDuration(0);
        setIsPlaying(true);

        loadAndPlayTrack(track);
    };

    const togglePlay = () => {
        if (!audioRef.current) return;
        if (audioRef.current.paused) {
            audioRef.current.play().then(() => setIsPlaying(true)).catch(() => setIsPlaying(false));
        } else {
            audioRef.current.pause();
            setIsPlaying(false);
        }
    };

    const handleSeek = (e) => {
        if (!audioRef.current || !duration) return;
        const nextTime = Number(e.target.value);
        audioRef.current.currentTime = nextTime;
        setCurrentTime(nextTime);
    };

    const handleEnded = () => {
        const nextIndex = currentIndex + 1;
        if (nextIndex < tracks.length) {
            playTrackAt(nextIndex);
        } else {
            setIsPlaying(false);
        }
    };

    if (!hasTracks && !spotifylink && !youtubelink) return null;

    return (
        <div>
            <div className="ctnportada" onClick={handleOpen}>
                <img src={escuchar} alt="escuchar"></img>
                <p>ESCUCHAR</p>

                <Modal open={open} onClose={handleClose} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
                    <div style={modalStyle} className={classes.paper}>
                        <p onClick={handleClose} className="xmodal">x</p>
                        <ClickAwayListener onClickAway={handleClickAway}>
                            <div style={{ height: "100%" }}>
                                <div className="modalaudio">
                                    <div className="sec1">
                                        <img src={imagen ? site + imagen.url : null} alt={na || 'audio'} height="300px" width="300px"></img>

                                        <div className="spotiyt">
                                            {youtubelink ? <a href={youtubelink} target="_blank" rel="noopener noreferrer"><img src={yt} alt="YouTube" /></a> : null}
                                            {spotifylink ? <a href={spotifylink} target="_blank" rel="noopener noreferrer"><img src={spotify} alt="Spotify" /></a> : null}
                                        </div>
                                        <div className="spotiyt spr">
                                            <a href="http://guasasapo.cl/granada" target="_blank" rel="noopener noreferrer"><img src={granada} alt="Granada"></img></a>
                                        </div>
                                    </div>
                                    <div>
                                        <h3><b>{naa}</b></h3>
                                        <h2>{na}</h2>
                                        <h3>{Moment(ano).format("YYYY")}<span className="ano sp12">{numcanciones ? ` ${numcanciones} Canciones / ${minutosalbum} Minutos` : ''}</span></h3>
                                        {hasTracks ? (
                                            <div className="canciones" style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'flex-start', marginTop: '18px', marginLeft: '49px', paddingLeft: '0', maxWidth: '520px' }}>
                                                {tracks.map((track, index) => (
                                                    <button
                                                        type="button"
                                                        key={`${track.numerocontenido}-${track.nombre}`}
                                                        onClick={() => playTrackAt(index)}
                                                        style={{
                                                            cursor: 'pointer',
                                                            background: 'transparent',
                                                            border: 0,
                                                            padding: 0,
                                                            textAlign: 'left',
                                                            width: '100%',
                                                            fontSize: '16px',
                                                            lineHeight: 1.2,
                                                            color: '#ffffff',
                                                            fontWeight: 400,
                                                            fontFamily: 'Arial, Helvetica, sans-serif',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '10px'
                                                        }}
                                                    >
                                                        <span style={{ color: currentIndex === index ? '#8e5abf' : 'transparent', width: '12px', display: 'inline-block', fontSize: '15px', lineHeight: 1 }}>▶</span>
                                                        <span>{`${track.numerocontenido}. ${track.nombre}`}</span>
                                                    </button>
                                                ))}
                                            </div>
                                        ) : (
                                            <div className="canciones">
                                                <p style={{ cursor: 'default' }}>Escucha disponible en las plataformas enlazadas.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {hasTracks ? (
                                    <div style={{ marginTop: '16px' }}>
                                        <audio
                                            ref={audioRef}
                                            preload="metadata"
                                            onTimeUpdate={(e) => setCurrentTime(e.currentTarget.currentTime || 0)}
                                            onLoadedMetadata={(e) => setDuration(e.currentTarget.duration || 0)}
                                            onPlay={() => {
                                                setIsPlaying(true);
                                            }}
                                            onPause={() => setIsPlaying(false)}
                                            onEnded={handleEnded}
                                        />

                                        <div style={{ display: 'flex', alignItems: 'center', gap: '14px', width: '100%', marginTop: '6px' }}>
                                            <button
                                                type="button"
                                                onClick={togglePlay}
                                                style={{
                                                    background: 'transparent',
                                                    border: '1px solid #666',
                                                    color: '#fff',
                                                    width: '42px',
                                                    height: '42px',
                                                    borderRadius: '999px',
                                                    cursor: 'pointer',
                                                    fontSize: '16px'
                                                }}
                                            >
                                                {isPlaying ? '❚❚' : '▶'}
                                            </button>

                                            <input
                                                type="range"
                                                min="0"
                                                max={duration || 0}
                                                step="0.1"
                                                value={Math.min(currentTime, duration || 0)}
                                                onChange={handleSeek}
                                                onInput={handleSeek}
                                                style={{ flex: 1, accentColor: '#8e5abf' }}
                                            />

                                            <div style={{ color: '#ffffff', fontSize: '14px', letterSpacing: '0.04em', minWidth: '108px', textAlign: 'right' }}>
                                                {formatTime(currentTime)} / {formatTime(duration)}
                                            </div>
                                        </div>
                                    </div>
                                ) : spotifylink ? (
                                    <iframe
                                        title="Spotify"
                                        src={spotifyEmbed(spotifylink)}
                                        width="100%"
                                        height="352"
                                        frameBorder="0"
                                        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                                        loading="lazy"
                                        style={{ marginTop: '16px' }}
                                    />
                                ) : youtubelink ? (
                                    <iframe
                                        title="YouTube"
                                        src={youtubelink.replace('watch?v=', 'embed/').replace('youtu.be/', 'youtube.com/embed/')}
                                        width="100%"
                                        height="352"
                                        frameBorder="0"
                                        allow="autoplay; encrypted-media; picture-in-picture"
                                        allowFullScreen
                                        style={{ marginTop: '16px' }}
                                    />
                                ) : null}
                            </div>
                        </ClickAwayListener>
                    </div>
                </Modal>
            </div>
        </div>
    );
}
